import HappyFace from '../../images/Icons/happy-face-icon.svg';
import Box from '../../images/Icons/simple-box-icon.svg';
import Shield from '../../images/Icons/shield-icon.svg';

export const callouts = [
  { icon: HappyFace, text: 'Happiness guaranteed' },
  { icon: Box, text: 'Flexible delivery' },
  { icon: Shield, text: 'Cancel anytime' },
];
